<script setup lang="ts">
import SuccessCard from '@/components/success-view/success-card.vue';
import useCountry from '@/composables/countryDependable';
import { useAnalytics } from '@/composables/useAnalytics';
import { useApplicationStore } from '@/store/application';
import { useCartStore } from '@/store/cart';
import { onMounted } from 'vue';

const props = defineProps<{
    stripe_id?: string
    paypal_id?: string
}>();

const analytics = useAnalytics();
const cartStore = useCartStore();
const appStore = useApplicationStore()
const country = useCountry();

onMounted(() => {
    //if cartStore.totalPrice is 0, then don't send purchase events
    if (cartStore.totalPrice > 0) {

        // if no transaction id, then don't send purchase events
        if (props.stripe_id === undefined && props.paypal_id === undefined) {
            //let's enable this a week after the feature is available
            return;
        }

        analytics.sendEvent('purchase', {
            transaction_id: appStore.appReference,
            currency: country.currencyName.trim(),
            value: cartStore.totalPrice
        });

        // ref: https://help.ads.microsoft.com/#apex/ads/en/56684/2
        window.uetq.push('event', 'bing_conversion_payment', {
            'event_category': 'payment&applicationRef:' + appStore.appReference,
            'event_label': country.currencyName.trim(),
            'event_value': cartStore.totalPrice
        });

        window.uetq.push('event', 'bing_conversion_purchase', {
            'event_category': 'payment_success',
            'event_label': appStore.appReference,
            'event_value': cartStore.totalPrice
        });
    }
})

</script>

<template>
    <SuccessCard class="my-3" />
</template>